/* Gängige Fahrzeuge für den Fitment-Finder: Hersteller > Modell > Motor / Variante.
   Erweiterbar: einfach Einträge ergänzen. Reihenfolge wird so übernommen. */
window.HIRSCH_VEHICLES = {
  "Alfa Romeo": {
    "Giulia": ["2.0 Turbo 200 PS", "2.0 Turbo 280 PS", "2.2 Diesel 160 PS", "Quadrifoglio 2.9 V6 510 PS"],
    "Stelvio": ["2.0 Turbo 200 PS", "2.0 Turbo 280 PS", "2.2 Diesel 210 PS", "Quadrifoglio 2.9 V6 510 PS"],
    "Tonale": ["1.3 Plug-in Hybrid Q4 280 PS", "1.5 Hybrid 160 PS"],
    "Giulietta": ["1.4 TB 170 PS", "1.75 TBi Quadrifoglio Verde 240 PS"]
  },
  "Aston Martin": {
    "Vantage": ["4.0 V8 510 PS", "4.0 V8 665 PS (2024)"],
    "DB11": ["4.0 V8 510 PS", "5.2 V12 608 PS"],
    "DB12": ["4.0 V8 680 PS"],
    "DBX": ["4.0 V8 550 PS", "DBX707 707 PS"],
    "DBS Superleggera": ["5.2 V12 725 PS"]
  },
  "Audi": {
    "A1": ["25 TFSI 95 PS", "30 TFSI 110 PS", "35 TFSI 150 PS", "40 TFSI 200 PS"],
    "A3 / S3 / RS3": ["35 TFSI 150 PS", "35 TDI 150 PS", "40 TFSI e 204 PS", "S3 2.0 TFSI 310 PS", "RS3 2.5 TFSI 400 PS"],
    "A4 / S4 / RS4": ["35 TFSI 150 PS", "40 TDI 204 PS", "45 TFSI 265 PS", "S4 3.0 TFSI 354 PS", "S4 3.0 TDI 347 PS", "RS4 Avant 2.9 TFSI 450 PS"],
    "A5 / S5 / RS5": ["40 TFSI 190 PS", "45 TFSI 265 PS", "S5 3.0 TFSI 354 PS", "RS5 2.9 TFSI 450 PS"],
    "A6 / S6 / RS6": ["40 TDI 204 PS", "45 TFSI 245 PS", "50 TDI 286 PS", "55 TFSI e 367 PS", "S6 TDI 349 PS", "RS6 Avant 4.0 TFSI 600 PS", "RS6 Performance 630 PS"],
    "A7 / S7 / RS7": ["45 TFSI 245 PS", "50 TDI 286 PS", "55 TFSI 340 PS", "S7 TDI 349 PS", "RS7 4.0 TFSI 600 PS"],
    "A8 / S8": ["50 TDI 286 PS", "55 TFSI 340 PS", "60 TFSI e 449 PS", "S8 4.0 TFSI 571 PS"],
    "Q2": ["30 TFSI 110 PS", "35 TFSI 150 PS", "SQ2 2.0 TFSI 300 PS"],
    "Q3 / RS Q3": ["35 TFSI 150 PS", "40 TFSI 190 PS", "45 TFSI e 245 PS", "RS Q3 2.5 TFSI 400 PS"],
    "Q5 / SQ5": ["40 TDI 204 PS", "45 TFSI 265 PS", "50 TFSI e 299 PS", "SQ5 3.0 TFSI 354 PS", "SQ5 TDI 341 PS"],
    "Q7 / SQ7": ["45 TDI 231 PS", "50 TDI 286 PS", "55 TFSI 340 PS", "SQ7 4.0 TFSI 507 PS"],
    "Q8 / SQ8 / RS Q8": ["50 TDI 286 PS", "55 TFSI 340 PS", "SQ8 4.0 TFSI 507 PS", "RS Q8 4.0 TFSI 600 PS", "RS Q8 Performance 640 PS"],
    "e-tron / Q4 e-tron / Q8 e-tron": ["Q4 40 e-tron 204 PS", "Q4 50 e-tron quattro 299 PS", "Q8 50 e-tron 340 PS", "Q8 55 e-tron 408 PS", "SQ8 e-tron 503 PS"],
    "e-tron GT / RS e-tron GT": ["e-tron GT quattro 476 PS", "RS e-tron GT 598 PS", "RS e-tron GT performance 925 PS"],
    "TT / TTS / TT RS": ["40 TFSI 197 PS", "45 TFSI 245 PS", "TTS 2.0 TFSI 320 PS", "TT RS 2.5 TFSI 400 PS"],
    "R8": ["V10 5.2 FSI 540 PS", "V10 plus 610 PS", "V10 performance 620 PS"]
  },
  "Bentley": {
    "Continental GT": ["4.0 V8 550 PS", "W12 635 PS", "Speed 659 PS", "Speed Plug-in Hybrid 782 PS"],
    "Flying Spur": ["4.0 V8 550 PS", "W12 635 PS", "Hybrid 544 PS"],
    "Bentayga": ["4.0 V8 550 PS", "Hybrid 449 PS", "Speed W12 635 PS"]
  },
  "BMW": {
    "1er (F40)": ["116i 109 PS", "118i 140 PS", "120d 190 PS", "M135i xDrive 306 PS"],
    "2er Coupé / Gran Coupé": ["218i 140 PS", "220i 184 PS", "M240i xDrive 374 PS", "M2 (G87) 460 PS"],
    "3er (G20 / G21)": ["318i 156 PS", "320i 184 PS", "320d 190 PS", "330i 258 PS", "330e 292 PS", "M340i 374 PS", "M340d 340 PS"],
    "M3 / M3 Touring (G80 / G81)": ["M3 480 PS", "M3 Competition 510 PS", "M3 Competition xDrive 510 PS", "M3 CS 550 PS"],
    "4er (G22 / G23 / G26)": ["420i 184 PS", "430i 258 PS", "420d 190 PS", "M440i 374 PS"],
    "M4 (G82 / G83)": ["M4 480 PS", "M4 Competition 510 PS", "M4 Competition xDrive 510 PS", "M4 CSL 550 PS"],
    "5er (G30 / G60)": ["520i 184 PS", "520d 190 PS", "530i 252 PS", "540i xDrive 340 PS", "530e 292 PS", "i5 eDrive40 340 PS", "i5 M60 601 PS"],
    "M5 (F90 / G90)": ["M5 600 PS", "M5 Competition 625 PS", "M5 CS 635 PS", "M5 (G90) Hybrid 727 PS"],
    "7er (G70)": ["740d xDrive 300 PS", "750e xDrive 489 PS", "760i xDrive 544 PS", "i7 xDrive60 544 PS"],
    "8er (G14 / G15 / G16)": ["840i 340 PS", "M850i xDrive 530 PS", "M8 Competition 625 PS"],
    "X1": ["sDrive18i 136 PS", "xDrive23i 218 PS", "xDrive23d 211 PS", "xDrive30e 326 PS", "iX1 xDrive30 313 PS"],
    "X3 / X3 M": ["xDrive20i 184 PS", "xDrive20d 190 PS", "xDrive30i 245 PS", "xDrive30e 292 PS", "M40i 360 PS", "X3 M Competition 510 PS"],
    "X5 / X5 M": ["xDrive30d 298 PS", "xDrive40i 340 PS", "xDrive50e 489 PS", "M60i 530 PS", "X5 M Competition 625 PS"],
    "X6 / X6 M": ["xDrive30d 298 PS", "xDrive40i 340 PS", "M60i 530 PS", "X6 M Competition 625 PS"],
    "X7": ["xDrive40d 340 PS", "xDrive40i 380 PS", "M60i 530 PS"],
    "Z4": ["sDrive20i 197 PS", "sDrive30i 258 PS", "M40i 340 PS"],
    "iX / i4": ["i4 eDrive40 340 PS", "i4 M50 544 PS", "iX xDrive40 326 PS", "iX xDrive50 523 PS", "iX M60 619 PS"],
    "M2 (F87)": ["M2 Competition 410 PS", "M2 CS 450 PS"]
  },
  "Cupra": {
    "Born": ["58 kWh 204 PS", "77 kWh 231 PS"],
    "Formentor": ["1.5 TSI 150 PS", "2.0 TSI 190 PS", "2.0 TSI 310 PS", "VZ5 2.5 TSI 390 PS"],
    "Leon": ["1.5 TSI 150 PS", "1.4 e-Hybrid 245 PS", "2.0 TSI 300 PS", "2.0 TSI 310 PS"],
    "Ateca": ["2.0 TSI 300 PS"]
  },
  "Dacia": {
    "Duster": ["1.0 TCe 100 PS", "1.3 TCe 130 PS", "1.6 Hybrid 140 PS"],
    "Sandero / Sandero Stepway": ["1.0 TCe 90 PS", "1.0 TCe 110 PS"],
    "Jogger": ["1.0 TCe 110 PS", "1.6 Hybrid 140 PS"]
  },
  "Ferrari": {
    "296 GTB / GTS": ["3.0 V6 Hybrid 830 PS"],
    "488 GTB / Spider / Pista": ["3.9 V8 670 PS", "Pista 720 PS"],
    "F8 Tributo / Spider": ["3.9 V8 720 PS"],
    "812 Superfast / GTS / Competizione": ["6.5 V12 800 PS", "Competizione 830 PS"],
    "Roma / Portofino": ["3.9 V8 620 PS", "Portofino M 620 PS"],
    "SF90 Stradale / Spider": ["4.0 V8 Hybrid 1000 PS"],
    "Purosangue": ["6.5 V12 725 PS"],
    "California / California T": ["4.3 V8 460 PS", "3.9 V8 560 PS"],
    "458 Italia / Speciale": ["4.5 V8 570 PS", "Speciale 605 PS"]
  },
  "Fiat / Abarth": {
    "500 / 500e": ["1.0 Hybrid 70 PS", "500e 42 kWh 118 PS", "Abarth 595 165 PS", "Abarth 695 180 PS", "Abarth 500e 155 PS"],
    "Panda": ["1.0 Hybrid 70 PS"],
    "Tipo": ["1.0 T3 100 PS", "1.5 Hybrid 130 PS"]
  },
  "Ford": {
    "Fiesta": ["1.0 EcoBoost 100 PS", "1.0 EcoBoost 125 PS", "ST 1.5 EcoBoost 200 PS"],
    "Focus": ["1.0 EcoBoost 125 PS", "1.5 EcoBoost 150 PS", "2.0 EcoBlue 150 PS", "ST 2.3 EcoBoost 280 PS", "ST 2.3 EcoBoost 280 PS (Kombi)"],
    "Kuga": ["1.5 EcoBoost 150 PS", "2.5 Plug-in Hybrid 225 PS", "2.5 Hybrid 190 PS"],
    "Puma": ["1.0 EcoBoost Hybrid 125 PS", "1.0 EcoBoost Hybrid 155 PS", "ST 1.5 EcoBoost 200 PS"],
    "Mustang": ["2.3 EcoBoost 290 PS", "5.0 V8 GT 450 PS", "5.0 V8 Mach 1 460 PS", "Mustang Mach-E 98 kWh 294 PS"],
    "Ranger": ["2.0 EcoBlue 170 PS", "2.0 EcoBlue Bi-Turbo 205 PS", "Raptor 3.0 V6 292 PS"]
  },
  "Honda": {
    "Civic": ["1.0 VTEC Turbo 129 PS", "1.5 VTEC Turbo 182 PS", "Type R 2.0 VTEC Turbo 329 PS"],
    "CR-V": ["2.0 i-MMD Hybrid 184 PS", "2.0 Plug-in Hybrid 184 PS"],
    "HR-V": ["1.5 i-MMD Hybrid 131 PS"],
    "Jazz": ["1.5 i-MMD Hybrid 109 PS"]
  },
  "Hyundai": {
    "i20 / i20 N": ["1.0 T-GDi 100 PS", "1.0 T-GDi 120 PS", "i20 N 1.6 T-GDi 204 PS"],
    "i30 / i30 N": ["1.0 T-GDi 120 PS", "1.5 T-GDi 160 PS", "i30 N 2.0 T-GDi 280 PS"],
    "Tucson": ["1.6 T-GDi 150 PS", "1.6 T-GDi Hybrid 230 PS", "1.6 T-GDi Plug-in Hybrid 265 PS"],
    "Kona / Kona N": ["1.0 T-GDi 120 PS", "1.6 T-GDi Hybrid 141 PS", "Kona Elektro 65 kWh 218 PS", "Kona N 2.0 T-GDi 280 PS"],
    "IONIQ 5 / IONIQ 5 N": ["58 kWh 170 PS", "77.4 kWh 229 PS", "77.4 kWh AWD 325 PS", "IONIQ 5 N 650 PS"],
    "IONIQ 6": ["77.4 kWh 229 PS", "77.4 kWh AWD 325 PS"]
  },
  "Jaguar": {
    "F-Type": ["2.0 Turbo 300 PS", "5.0 V8 450 PS", "R 5.0 V8 575 PS", "R75 575 PS"],
    "F-Pace": ["2.0 D 204 PS", "P400 3.0 400 PS", "SVR 5.0 V8 550 PS"],
    "E-Pace": ["2.0 P200 200 PS", "2.0 P300 300 PS"],
    "I-Pace": ["EV400 400 PS"]
  },
  "Kia": {
    "Ceed / Proceed / XCeed": ["1.0 T-GDi 120 PS", "1.5 T-GDi 160 PS", "GT 1.6 T-GDi 204 PS"],
    "Sportage": ["1.6 T-GDi 150 PS", "1.6 T-GDi Hybrid 230 PS", "1.6 T-GDi Plug-in Hybrid 265 PS"],
    "Sorento": ["1.6 T-GDi Hybrid 230 PS", "1.6 T-GDi Plug-in Hybrid 265 PS"],
    "EV6 / EV6 GT": ["58 kWh 170 PS", "77.4 kWh 229 PS", "77.4 kWh AWD 325 PS", "EV6 GT 585 PS"],
    "Stinger": ["2.0 T-GDi 255 PS", "3.3 T-GDi V6 366 PS"]
  },
  "Lamborghini": {
    "Huracán": ["LP 580-2 580 PS", "LP 610-4 610 PS", "Evo 640 PS", "Performante 640 PS", "STO 640 PS", "Tecnica 640 PS", "Sterrato 610 PS"],
    "Urus": ["4.0 V8 650 PS", "Performante 666 PS", "S 666 PS"],
    "Aventador": ["LP 700-4 700 PS", "S 740 PS", "SVJ 770 PS", "Ultimae 780 PS"],
    "Revuelto": ["6.5 V12 Hybrid 1015 PS"],
    "Gallardo": ["LP 560-4 560 PS", "LP 570-4 Superleggera 570 PS"]
  },
  "Land Rover": {
    "Defender": ["90 / 110 P300 300 PS", "110 D250 250 PS", "110 P400 400 PS", "110 P525 525 PS V8"],
    "Discovery / Discovery Sport": ["D200 200 PS", "D250 250 PS", "P300 300 PS"],
    "Range Rover": ["D350 350 PS", "P400 400 PS", "P530 530 PS V8", "P550e 550 PS", "SV 615 PS"],
    "Range Rover Sport": ["D300 300 PS", "P400 400 PS", "P530 V8 530 PS", "SV 635 PS"],
    "Range Rover Velar": ["D200 204 PS", "P250 250 PS", "P400 400 PS"],
    "Range Rover Evoque": ["D165 163 PS", "P200 200 PS", "P300 300 PS"]
  },
  "Lexus": {
    "IS": ["300h 223 PS", "IS 500 F Sport 5.0 V8 477 PS"],
    "NX": ["350h 242 PS", "450h+ 309 PS"],
    "RX": ["350h 250 PS", "450h+ 309 PS", "500h 371 PS"],
    "UX": ["250h 184 PS", "300e 204 PS"],
    "LC": ["500 5.0 V8 477 PS", "500h 359 PS"]
  },
  "Maserati": {
    "Ghibli": ["3.0 V6 Diesel 275 PS", "3.0 V6 Modena 350 PS", "3.0 V6 Trofeo 580 PS"],
    "Levante": ["3.0 V6 Diesel 275 PS", "3.0 V6 Modena 350 PS", "3.8 V8 Trofeo 580 PS"],
    "Quattroporte": ["3.0 V6 410 PS", "3.8 V8 580 PS"],
    "GranTurismo": ["Modena 3.0 V6 490 PS", "Trofeo 3.0 V6 550 PS", "Folgore 761 PS"],
    "MC20": ["3.0 V6 Nettuno 630 PS"],
    "Grecale": ["2.0 Mild-Hybrid 300 PS", "3.0 V6 Modena 330 PS", "3.0 V6 Trofeo 530 PS"]
  },
  "Mazda": {
    "Mazda2": ["1.5 Skyactiv-G 90 PS", "1.5 Hybrid 116 PS"],
    "Mazda3": ["2.0 Skyactiv-G 122 PS", "2.0 Skyactiv-X 186 PS", "2.5 Skyactiv-G 140 PS"],
    "CX-30": ["2.0 Skyactiv-G 122 PS", "2.0 Skyactiv-X 186 PS"],
    "CX-5": ["2.0 Skyactiv-G 165 PS", "2.5 Skyactiv-G 194 PS", "2.2 Skyactiv-D 150 PS"],
    "MX-5": ["1.5 Skyactiv-G 132 PS", "2.0 Skyactiv-G 184 PS"]
  },
  "McLaren": {
    "540C / 570S / 570GT": ["3.8 V8 540 PS", "3.8 V8 570 PS"],
    "600LT / 620R": ["3.8 V8 600 PS", "3.8 V8 620 PS"],
    "720S / 750S": ["4.0 V8 720 PS", "4.0 V8 750 PS"],
    "765LT": ["4.0 V8 765 PS"],
    "GT": ["4.0 V8 620 PS"],
    "Artura": ["3.0 V6 Hybrid 680 PS"],
    "650S / 675LT": ["3.8 V8 650 PS", "3.8 V8 675 PS"]
  },
  "Mercedes-Benz / AMG": {
    "A-Klasse (W177)": ["A 180 136 PS", "A 200 163 PS", "A 250 224 PS", "A 220 d 190 PS", "A 35 AMG 306 PS", "A 45 AMG 387 PS", "A 45 S AMG 421 PS"],
    "B-Klasse": ["B 180 136 PS", "B 200 163 PS", "B 250 e 218 PS"],
    "C-Klasse (W205 / W206)": ["C 180 170 PS", "C 200 204 PS", "C 220 d 200 PS", "C 300 258 PS", "C 300 e 313 PS", "C 43 AMG 390 PS", "C 63 AMG 4.0 V8 476 PS", "C 63 S AMG 510 PS", "C 63 S E Performance 680 PS"],
    "CLA / CLA Shooting Brake": ["CLA 200 163 PS", "CLA 250 224 PS", "CLA 35 AMG 306 PS", "CLA 45 S AMG 421 PS"],
    "E-Klasse (W213 / W214)": ["E 200 197 PS", "E 220 d 194 PS", "E 300 e 320 PS", "E 350 258 PS", "E 450 4MATIC 367 PS", "E 53 AMG 435 PS", "E 63 S AMG 612 PS"],
    "CLS": ["CLS 220 d 194 PS", "CLS 450 367 PS", "CLS 53 AMG 435 PS"],
    "S-Klasse (W223)": ["S 350 d 286 PS", "S 450 367 PS", "S 500 435 PS", "S 580 e 510 PS", "S 63 E Performance 802 PS"],
    "GLA / GLB": ["GLA 200 163 PS", "GLA 250 224 PS", "GLA 35 AMG 306 PS", "GLB 200 163 PS", "GLB 250 224 PS", "GLA / GLB 45 S AMG 421 PS"],
    "GLC / GLC Coupé": ["GLC 200 204 PS", "GLC 220 d 197 PS", "GLC 300 e 313 PS", "GLC 43 AMG 390 PS", "GLC 63 S E Performance 680 PS"],
    "GLE / GLE Coupé": ["GLE 300 d 245 PS", "GLE 350 de 333 PS", "GLE 450 367 PS", "GLE 53 AMG 435 PS", "GLE 63 S AMG 612 PS"],
    "GLS": ["GLS 400 d 330 PS", "GLS 450 367 PS", "GLS 580 489 PS", "GLS 63 AMG 612 PS"],
    "G-Klasse (W463)": ["G 400 d 330 PS", "G 450 d 367 PS", "G 500 422 PS", "G 63 AMG 585 PS"],
    "AMG GT / GT 4-Türer": ["GT 4.0 V8 476 PS", "GT S 522 PS", "GT C 557 PS", "GT R 585 PS", "GT 63 S 639 PS", "GT 63 S E Performance 843 PS"],
    "SL / SLC": ["SL 43 AMG 381 PS", "SL 55 AMG 476 PS", "SL 63 AMG 585 PS", "SLC 200 184 PS", "SLC 43 AMG 367 PS"],
    "EQC / EQE / EQS": ["EQC 400 4MATIC 408 PS", "EQE 350+ 292 PS", "EQE 53 AMG 626 PS", "EQS 450+ 333 PS", "EQS 580 4MATIC 516 PS", "EQS 53 AMG 658 PS"],
    "V-Klasse / Vito": ["V 220 d 163 PS", "V 250 d 190 PS", "V 300 d 239 PS"]
  },
  "MINI": {
    "Cooper / Cooper S (F55 / F56)": ["Cooper 1.5 136 PS", "Cooper S 2.0 192 PS", "Cooper SE Elektro 184 PS"],
    "John Cooper Works": ["JCW 2.0 231 PS", "JCW GP 306 PS"],
    "Countryman": ["Cooper 1.5 136 PS", "Cooper S 2.0 178 PS", "JCW 306 PS"],
    "Clubman": ["Cooper 136 PS", "Cooper S 192 PS", "JCW 306 PS"]
  },
  "Nissan": {
    "Qashqai": ["1.3 DIG-T 140 PS", "1.3 DIG-T 158 PS", "1.5 e-Power 190 PS"],
    "Juke": ["1.0 DIG-T 114 PS", "1.6 Hybrid 143 PS"],
    "Leaf": ["40 kWh 150 PS", "62 kWh 217 PS"],
    "GT-R": ["3.8 V6 570 PS", "Nismo 600 PS"],
    "370Z / 400Z": ["370Z 3.7 V6 328 PS", "400Z 3.0 V6 405 PS"]
  },
  "Opel": {
    "Corsa": ["1.2 75 PS", "1.2 Turbo 100 PS", "1.2 Turbo 130 PS", "Corsa-e 136 PS"],
    "Astra": ["1.2 Turbo 130 PS", "1.5 Diesel 130 PS", "1.6 Plug-in Hybrid 180 PS", "1.6 Plug-in Hybrid 225 PS"],
    "Mokka": ["1.2 Turbo 130 PS", "Mokka-e 136 PS"],
    "Insignia": ["1.5 Turbo 165 PS", "2.0 Diesel 174 PS", "2.0 Turbo 230 PS"]
  },
  "Peugeot": {
    "208 / e-208": ["1.2 PureTech 100 PS", "1.2 PureTech 130 PS", "e-208 136 PS"],
    "308": ["1.2 PureTech 130 PS", "1.5 BlueHDi 130 PS", "1.6 Plug-in Hybrid 180 PS", "1.6 Plug-in Hybrid 225 PS"],
    "2008": ["1.2 PureTech 130 PS", "e-2008 136 PS"],
    "3008 / 5008": ["1.2 PureTech 130 PS", "1.6 Plug-in Hybrid 225 PS", "1.5 BlueHDi 130 PS"]
  },
  "Polestar": {
    "Polestar 2": ["Standard Range 272 PS", "Long Range Single Motor 299 PS", "Long Range Dual Motor 421 PS"],
    "Polestar 3": ["Long Range Dual Motor 489 PS", "Performance 517 PS"],
    "Polestar 4": ["Long Range Single Motor 272 PS", "Long Range Dual Motor 544 PS"]
  },
  "Porsche": {
    "911 (991)": ["Carrera 3.0 370 PS", "Carrera S 420 PS", "Carrera 4S 420 PS", "Turbo 3.8 540 PS", "Turbo S 580 PS", "GT3 3.8 475 PS", "GT3 RS 4.0 520 PS", "GT2 RS 700 PS"],
    "911 (992)": ["Carrera 3.0 385 PS", "Carrera S 450 PS", "Carrera 4S 450 PS", "Carrera GTS 480 PS", "Turbo 3.7 580 PS", "Turbo S 650 PS", "GT3 4.0 510 PS", "GT3 RS 525 PS", "Targa 4 GTS 480 PS", "Dakar 480 PS"],
    "911 (997)": ["Carrera 3.6 325 PS", "Carrera S 3.8 385 PS", "Turbo 3.6 480 PS", "GT3 3.6 415 PS", "GT3 RS 4.0 500 PS"],
    "718 Cayman / Boxster": ["2.0 300 PS", "2.5 S 350 PS", "GTS 4.0 400 PS", "GT4 4.0 420 PS", "GT4 RS 500 PS", "Spyder 4.0 420 PS"],
    "Panamera": ["3.0 V6 330 PS", "4S 2.9 V6 440 PS", "GTS 4.0 V8 480 PS", "Turbo S 4.0 V8 630 PS", "4 E-Hybrid 462 PS", "Turbo S E-Hybrid 700 PS"],
    "Macan": ["2.0 265 PS", "S 3.0 354 PS", "GTS 2.9 380 PS", "Turbo 2.9 440 PS", "Macan Electric 4 408 PS", "Macan Turbo Electric 639 PS"],
    "Cayenne": ["3.0 V6 340 PS", "S 2.9 V6 440 PS", "GTS 4.0 V8 460 PS", "Turbo 4.0 V8 550 PS", "Turbo GT 640 PS", "E-Hybrid 470 PS", "Turbo S E-Hybrid 680 PS"],
    "Taycan": ["4S 571 PS", "GTS 598 PS", "Turbo 680 PS", "Turbo S 761 PS", "Turbo GT 1034 PS"],
    "Cayenne Coupé": ["3.0 V6 340 PS", "S 440 PS", "GTS 460 PS", "Turbo 550 PS", "Turbo GT 640 PS"]
  },
  "Renault": {
    "Clio": ["1.0 TCe 90 PS", "1.3 TCe 140 PS", "1.6 E-Tech Hybrid 145 PS"],
    "Megane / Megane E-Tech": ["1.3 TCe 140 PS", "E-Tech Electric 130 PS", "E-Tech Electric 218 PS", "R.S. Trophy 1.8 300 PS"],
    "Captur": ["1.3 TCe 140 PS", "1.6 E-Tech Plug-in Hybrid 160 PS"],
    "Arkana": ["1.3 TCe 140 PS", "1.6 E-Tech Hybrid 145 PS"]
  },
  "Rolls-Royce": {
    "Ghost": ["6.75 V12 571 PS", "Black Badge 601 PS"],
    "Wraith / Dawn": ["6.6 V12 632 PS", "Black Badge 601 PS"],
    "Cullinan": ["6.75 V12 571 PS", "Black Badge 600 PS"],
    "Phantom": ["6.75 V12 571 PS"],
    "Spectre": ["Elektro 102 kWh 585 PS"]
  },
  "Seat": {
    "Ibiza": ["1.0 TSI 95 PS", "1.0 TSI 110 PS", "1.5 TSI 150 PS"],
    "Leon": ["1.0 TSI 110 PS", "1.5 TSI 150 PS", "2.0 TDI 150 PS", "1.4 e-Hybrid 204 PS"],
    "Arona": ["1.0 TSI 110 PS"],
    "Ateca": ["1.5 TSI 150 PS", "2.0 TDI 150 PS"],
    "Tarraco": ["1.5 TSI 150 PS", "2.0 TSI 190 PS", "1.4 e-Hybrid 245 PS"]
  },
  "Škoda": {
    "Fabia": ["1.0 TSI 95 PS", "1.0 TSI 110 PS", "1.5 TSI 150 PS"],
    "Octavia / Octavia RS": ["1.0 TSI 110 PS", "1.5 TSI 150 PS", "2.0 TDI 150 PS", "1.4 iV 204 PS", "RS 2.0 TSI 245 PS", "RS 2.0 TDI 200 PS"],
    "Superb": ["1.5 TSI 150 PS", "2.0 TSI 190 PS", "2.0 TSI 272 PS", "1.4 iV 218 PS"],
    "Kodiaq / Kodiaq RS": ["1.5 TSI 150 PS", "2.0 TSI 190 PS", "2.0 TDI 200 PS", "RS 2.0 TSI 245 PS"],
    "Karoq": ["1.0 TSI 110 PS", "1.5 TSI 150 PS", "2.0 TDI 150 PS"],
    "Kamiq / Scala": ["1.0 TSI 95 PS", "1.0 TSI 110 PS", "1.5 TSI 150 PS"],
    "Enyaq iV / Enyaq Coupé": ["60 180 PS", "80 204 PS", "80x 265 PS", "RS 340 PS"]
  },
  "Subaru": {
    "Impreza / WRX": ["Impreza 2.0 i 156 PS", "WRX STI 2.5 300 PS", "WRX 2.4 275 PS"],
    "Forester": ["2.0 e-Boxer 150 PS"],
    "Outback": ["2.5 169 PS"],
    "BRZ": ["2.4 234 PS"]
  },
  "Tesla": {
    "Model 3": ["Standard Range RWD 283 PS", "Long Range AWD 498 PS", "Performance 513 PS"],
    "Model Y": ["RWD 299 PS", "Long Range AWD 514 PS", "Performance 534 PS"],
    "Model S": ["Long Range 670 PS", "Plaid 1020 PS"],
    "Model X": ["Long Range 670 PS", "Plaid 1020 PS"]
  },
  "Toyota": {
    "Yaris / GR Yaris": ["1.5 Hybrid 116 PS", "GR Yaris 1.6 261 PS", "GR Yaris 1.6 280 PS"],
    "Corolla": ["1.8 Hybrid 140 PS", "2.0 Hybrid 196 PS", "GR Corolla 1.6 300 PS"],
    "C-HR": ["1.8 Hybrid 140 PS", "2.0 Hybrid 184 PS"],
    "RAV4": ["2.5 Hybrid 222 PS", "2.5 Plug-in Hybrid 306 PS"],
    "GR Supra": ["2.0 258 PS", "3.0 340 PS", "3.0 387 PS"],
    "GR86": ["2.4 234 PS"],
    "Land Cruiser": ["2.8 D-4D 204 PS", "3.3 V6 D 305 PS"]
  },
  "Volvo": {
    "XC40 / EX40": ["B3 163 PS", "B4 197 PS", "T5 Recharge 262 PS", "Recharge Twin 408 PS"],
    "XC60": ["B4 197 PS", "B5 250 PS", "T6 Recharge 350 PS", "T8 Recharge 455 PS"],
    "XC90": ["B5 250 PS", "B6 300 PS", "T8 Recharge 455 PS"],
    "V60 / V60 Cross Country": ["B3 163 PS", "B4 197 PS", "T6 Recharge 350 PS", "T8 Polestar Engineered 455 PS"],
    "V90 / S90": ["B4 197 PS", "B5 250 PS", "T8 Recharge 455 PS"],
    "C40 / EX30 / EX90": ["C40 Recharge 231 PS", "C40 Recharge Twin 408 PS", "EX30 272 PS", "EX90 Twin 517 PS"]
  },
  "VW": {
    "Polo / Polo GTI": ["1.0 TSI 95 PS", "1.0 TSI 110 PS", "GTI 2.0 TSI 207 PS"],
    "Golf (VII / VIII)": ["1.0 TSI 110 PS", "1.5 TSI 130 PS", "1.5 TSI 150 PS", "2.0 TDI 150 PS", "GTE 1.4 245 PS", "e-Golf 136 PS"],
    "Golf GTI / GTD / Clubsport": ["GTI 2.0 TSI 245 PS", "GTI Clubsport 300 PS", "GTI Clubsport 45 Edition 300 PS", "GTD 2.0 TDI 200 PS"],
    "Golf R": ["R 2.0 TSI 300 PS", "R 2.0 TSI 320 PS", "R 20 Years 333 PS"],
    "ID.3 / ID.4 / ID.5": ["ID.3 Pro 204 PS", "ID.3 GTX 326 PS", "ID.4 Pro 204 PS", "ID.4 GTX 299 PS", "ID.5 Pro 204 PS"],
    "ID.7 / ID.Buzz": ["ID.7 Pro 286 PS", "ID.Buzz Pro 204 PS"],
    "Passat": ["1.5 TSI 150 PS", "2.0 TDI 150 PS", "2.0 TDI 200 PS", "GTE 1.4 218 PS"],
    "Arteon / Arteon R": ["2.0 TSI 190 PS", "2.0 TSI 280 PS", "2.0 TDI 200 PS", "R 320 PS"],
    "T-Roc / T-Roc R": ["1.0 TSI 110 PS", "1.5 TSI 150 PS", "2.0 TDI 150 PS", "R 2.0 TSI 300 PS"],
    "Tiguan / Tiguan R": ["1.5 TSI 150 PS", "2.0 TDI 150 PS", "2.0 TDI 200 PS", "eHybrid 245 PS", "R 320 PS"],
    "Touareg": ["3.0 V6 TDI 286 PS", "R eHybrid 462 PS"],
    "T-Cross / Taigo": ["1.0 TSI 95 PS", "1.0 TSI 110 PS", "1.5 TSI 150 PS"],
    "Scirocco / Scirocco R": ["2.0 TSI 220 PS", "R 2.0 TSI 265 PS"],
    "T6 / T6.1 / T7 Multivan": ["2.0 TDI 150 PS", "2.0 TDI 204 PS", "2.0 TSI 204 PS", "T7 eHybrid 218 PS"]
  }
};
